/**
 * Vertical spoke pages — SSOT for the four merchant archetype landing pages.
 *
 * Order matters: `SPOKES` is the canonical navigation sequence used by the
 * bottom-of-page prev/next SpokeNav on every spoke.
 *
 * `built: true` gates the prev/next buttons — unbuilt spokes render as a
 * disabled "Coming soon" state instead of a broken link. Flip to `true` as
 * each spoke ships.
 *
 * The exported `SOLUTIONS_FOOTER_COLUMN` is imported by the LandingPage,
 * IntegrationsPage, and every spoke page so the footer stays in sync
 * everywhere in one edit.
 */

export const SPOKES = [
  {
    slug: 'for-restaurants',
    path: '/for-restaurants',
    name: 'Restaurants',
    shortLabel: 'Restaurants',
    built: true,
  },
  {
    slug: 'for-cafes-bakeries',
    path: '/for-cafes-bakeries',
    name: 'Cafes & Bakeries',
    shortLabel: 'Cafes & Bakeries',
    built: true,
  },
  {
    slug: 'for-grocery-specialty',
    path: '/for-grocery-specialty',
    name: 'Grocery & Specialty',
    shortLabel: 'Grocery & Specialty',
    built: true,
  },
  {
    slug: 'for-ghost-kitchens-popups',
    path: '/for-ghost-kitchens-popups',
    name: 'Ghost Kitchens & Pop-ups',
    shortLabel: 'Ghost Kitchens',
    built: true,
  },
];

export const getSpokeBySlug = (slug) => SPOKES.find((s) => s.slug === slug);

export const getAdjacentSpokes = (slug) => {
  const idx = SPOKES.findIndex((s) => s.slug === slug);
  return {
    prev: idx > 0 ? SPOKES[idx - 1] : null,
    next: idx >= 0 && idx < SPOKES.length - 1 ? SPOKES[idx + 1] : null,
  };
};

// Footer column shared across LandingPage, IntegrationsPage, and every spoke.
// Only shipped (`built: true`) spokes are listed — as new spokes ship, flip
// their `built` flag above and they automatically appear site-wide.
export const SOLUTIONS_FOOTER_COLUMN = {
  title: 'Solutions',
  links: SPOKES.filter((s) => s.built).map((s) => ({
    href: s.path,
    label: s.name,
    testId: `footer-solutions-${s.slug}`,
  })),
};
